// @flow
/* ***************************************************************************
* @author mfranco (mfranco@mobinteg.com)
*******************************************************************************/

import React, { Component } from "react"
import style from "./style.css"
import Checkbox from "react-toolbox/lib/checkbox"
import Dialog from "react-toolbox/lib/dialog"
import Division from "../../../components/Division"
import CreateInvoice from "../../../components/CreatePaymentAgreementComponents/CreateInvoice"
import { formatCurrency, formatDate } from "../../../utils"
import FontIcon from "react-toolbox/lib/font_icon"
import * as strings from "../../../strings"
import _ from "lodash"

export default class Invoices extends Component {
  props: {
    procedures: [],
    debt: any,
    paymentAgreementState: any,
    onChange: any,
    isPreLitigation: any,
  }

  state = {
    active: false,
    newInvoice: {
      id: undefined,
      value: undefined,
      date: undefined,
      expiryDate: undefined,
    },
    areInputFieldsValid: [ false, false, false, false ],
  }

  selectAllInvoices = ( preLitigationInvoices, litigationInvoices, initialState ) => {
    const { paymentAgreementState } = this.props

    const pickedInvoices = _.isEqual( preLitigationInvoices.length + litigationInvoices.length,
      paymentAgreementState.pickedInvoices.length ) ? [] : [ ...preLitigationInvoices, ...litigationInvoices ]
    const capitalValue = this.calculateCapitalValue( pickedInvoices, paymentAgreementState.addedInvoices )
    this.props.onChange( {
      pickedInvoices,
      capitalValue,
      debtValue: capitalValue,
      ...initialState,
    } )
  }

  calculateCapitalValue = ( pickedInvoices, addedInvoices ) => {
    const capitalValue = _.sum( pickedInvoices.map( invoice => parseFloat( invoice.value ) ) ) +
      _.sum( addedInvoices.map( invoice => parseFloat( invoice.value ) ) )
    return _.round( capitalValue, 2 )
  }

  selectOneInvoice = ( invoice, initialState ) => {
    const { pickedInvoices, addedInvoices } = this.props.paymentAgreementState
    const newPickedInvoices = pickedInvoices.includes( invoice )
      ? [ ..._.without( pickedInvoices, invoice ) ] : [ ...pickedInvoices, invoice ]
    const capitalValue = this.calculateCapitalValue( newPickedInvoices, addedInvoices )
    this.props.onChange( {
      pickedInvoices: newPickedInvoices,
      capitalValue,
      debtValue: capitalValue,
      ...initialState,
    } )
  }

  handleChange = ( event ) => {
    return this.setState( {
      newInvoice: {
        ...this.state.newInvoice,
        ...event,
      },
    } )
  }

  handleToggle = () => {
    this.setState( {
      active: !this.state.active,
      newInvoice: {
        documentNumber: undefined,
        value: undefined,
        date: undefined,
        expiryDate: undefined,
      },
      areInputFieldsValid: [ false, false, false, false ],
    } )
  }

  addExtraInvoice = ( initialState ) => {
    const { newInvoice } = this.state
    const errorMessage = <span> {strings.errorMessages.missingField} </span>
    const errorMessageToNegativeValues = <span> {strings.errorMessages.invalidValue} </span>

    let validInputs = [
      newInvoice.documentNumber ? false : errorMessage,
      newInvoice.value ? ( newInvoice.value < 0 ? errorMessageToNegativeValues : false ) : errorMessage,
      newInvoice.date ? false : errorMessage,
      newInvoice.expiryDate ? false : errorMessage,
    ]

    if ( _.isEqual( _.compact( validInputs ).length, 0 ) ) {
      const { paymentAgreementState } = this.props
      const newAddedInvoices = [ ...paymentAgreementState.addedInvoices, newInvoice ]
      const capitalValue = this.calculateCapitalValue( paymentAgreementState.pickedInvoices, newAddedInvoices )
      this.setState( {
        areInputFieldsValid: validInputs,
        active: !_.isEqual( _.compact( validInputs ).length, 0 ),
      }, () => this.props.onChange( {
        addedInvoices: newAddedInvoices,
        capitalValue,
        debtValue: capitalValue,
        ...initialState,
      } ) )

    }

    this.setState( {
      areInputFieldsValid: validInputs,
      active: !_.isEqual( _.compact( validInputs ).length, 0 ),
    } )
  }


  getContractNumber = ( contracts, contractId ) => {
    const contractNumber = contracts.find( contract => _.isEqual( contract.id, contractId ) )
    return contractNumber ? contractNumber.contractNumber : undefined
  }

  deleteExtraInvoice = ( index, value, initialState ) => {
    const { paymentAgreementState } = this.props
    const newAddedInvoices = paymentAgreementState.addedInvoices.filter( ( invoice, i ) => !_.isEqual( i, index ) )
    const capitalValue = this.calculateCapitalValue( paymentAgreementState.pickedInvoices, newAddedInvoices )
    this.props.onChange( {
      addedInvoices: newAddedInvoices,
      capitalValue,
      debtValue: capitalValue,
      ...initialState,
    } )
  }

  render () {
    const initialState = {
      numberOfPayments: undefined,
      valuePerPayment: undefined,
      firstPaymentDate: new Date(),
      paymentDates: {},
      payments: {},
      isChangedPayment: {},
      interestValue: 0,
      newInvoices: [],
      justiceTax: this.props.isPreLitigation ? 0 : undefined,
      interestRate: 0,
      arePaymentInputsValid: [ false, false ],
      isClientValid: false,
      idInterestType: 0,
      taxValue: undefined,
    }

    const { generalStrings } = strings
    const { paymentAgreementState } = this.props
    const state = this.state

    const preLitigationFilteredArray = this.props.debt.preLitigations.filter( preLitigation =>
      ( Object.values( paymentAgreementState.checkBoxes ).indexOf( preLitigation.id ) !== -1 ) )

    const litigationFilteredArray = this.props.debt.litigations.filter( litigation =>
      ( Object.values( paymentAgreementState.checkBoxes ).indexOf( litigation.id ) !== -1 ) )

    const filteredPreLitigationInvoices = _.flattenDeep( preLitigationFilteredArray.map( preLitigation =>
      preLitigation.contracts.map( contract =>
        contract.invoices.map( invoice => invoice ) ) ) )

    const filteredLitigationInvoices = _.flattenDeep( litigationFilteredArray.map( litigation =>
      litigation.contracts.map( contract =>
        contract.invoices.map( invoice => invoice ) ) ) )

    const litigationContracts = _.flattenDeep( litigationFilteredArray.map( litigation => litigation.contracts ) )
    const preLitigationContracts = _.flattenDeep( preLitigationFilteredArray
      .map( preLitigation => preLitigation.contracts ) )

    return (

      <div className={style.mainContainer}>
        <div className={style.invoicesInfo}>
          <Division title={strings.invoices.invoices + strings.generalStrings.of + this.props.paymentAgreementState.clientName}/>
          <div className={style.contentContainer}>
            <table className={style.tableCss}>
              <thead>
                <tr>
                  <th className={style.checkBoxFix}>
                    <Checkbox
                      checked={_.isEqual( filteredPreLitigationInvoices.length + filteredLitigationInvoices.length, paymentAgreementState.pickedInvoices.length ) }
                      onChange={() => this.selectAllInvoices( filteredPreLitigationInvoices, filteredLitigationInvoices, initialState )}
                    />
                  </th>
                  <th className={style.tableTitle}><b>{strings.paymentAgreements.documentNumber}</b></th>
                  <th className={style.tableTitle}><b>{strings.paymentAgreements.contractNumber}</b></th>
                  <th className={style.tableTitle}><b>{strings.invoices.value}</b></th>
                  <th className={style.tableTitle}><b>{strings.invoices.emissionDate}</b></th>
                  <th className={style.tableTitle}><b>{strings.paymentAgreements.limitDate}</b></th>
                </tr>
              </thead>
              <tbody>
                {filteredPreLitigationInvoices.map( ( invoice, i ) => {
                  const contractNumber = this.getContractNumber( preLitigationContracts, invoice.idContract )
                  return <tr key={i}>
                    <td className={style.checkBoxFix}>
                      <Checkbox checked={this.props.paymentAgreementState.pickedInvoices.includes( invoice )}
                        onChange={ () => this.selectOneInvoice( invoice, initialState ) }
                      />
                    </td>
                    <td className={style.tdTitle}>{invoice.documentNumber}</td>
                    <td className={style.tdTitle}>{contractNumber || generalStrings.emptyField}</td>
                    <td className={style.tdTitle}>{invoice.value} {generalStrings.currency}</td>
                    <td className={style.tdTitle}>{formatDate( invoice.date )}</td>
                    <td className={style.tdTitle}>{formatDate( invoice.expiryDate )}</td>
                  </tr> } ) }
                {filteredLitigationInvoices.map( ( invoice, i ) => {
                  const contractNumber = this.getContractNumber( litigationContracts, invoice.idContract )
                  return <tr key={i}>
                    <td className={style.checkBoxFix}>
                      <Checkbox checked={this.props.paymentAgreementState.pickedInvoices.includes( invoice )}
                        onChange={ () => this.selectOneInvoice( invoice, initialState ) }
                      />
                    </td>
                    <td className={style.tdTitle}>{invoice.documentNumber}</td>
                    <td className={style.tdTitle}>{contractNumber || generalStrings.emptyField}</td>
                    <td className={style.tdTitle}>{invoice.value} {generalStrings.currency}</td>
                    <td className={style.tdTitle}>{formatDate( invoice.date )}</td>
                    <td className={style.tdTitle}>{formatDate( invoice.expiryDate )}</td>
                  </tr> } ) }
              </tbody>
            </table>

          </div>
          <div className={this.props.paymentAgreementState.addedInvoices.length === 0 ?
            style.hiddenContent : style.showContent}>
            <div className={style.firstDivisor}>
              <div className={style.firstLine}>
                <span><hr className={style.divider}/></span>
              </div>
              <div className={style.secondLine}>
                <span className={style.spanText}>{strings.invoices.addedInvoices} </span>
              </div>
              <div className={style.thirdLine}>
                <span><hr className={style.divider}/></span>
              </div>
            </div>
            <div className={style.contentContainer}>
              <table className={style.tableCss}>
                <thead>
                  <tr>
                    <th className={style.clearFix}/>
                    <th className={style.tableTitle}><b>{strings.invoices.invoice}</b></th>
                    <th className={style.tableTitle}><b>{strings.invoices.value}</b></th>
                    <th className={style.tableTitle}><b>{strings.invoices.emissionDate}</b></th>
                    <th className={style.tableTitle}><b>{strings.paymentAgreements.limitDate}</b></th>
                    <th className={style.tableTitle}><b>{strings.paymentAgreements.contractNumber}</b></th>
                    <th className={style.tableTitle}><b>Local de consumo</b></th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.paymentAgreementState.addedInvoices.map( ( addedInvoice, i ) => {
                    return <tr key={i}>
                      <td >
                        <div className={style.clearFix}
                          onClick={() => this.deleteExtraInvoice( i, addedInvoice, initialState )}>
                          <FontIcon>clear</FontIcon>
                        </div>
                      </td>
                      <td>{addedInvoice.documentNumber}</td>
                      <td>{formatCurrency( addedInvoice.value )}</td>
                      <td>{formatDate( addedInvoice.date )}</td>
                      <td>{formatDate( addedInvoice.expiryDate )}</td>
                      <td>{addedInvoice.contractNumber}</td>
                      <td>{addedInvoice.address}</td>
                    </tr>
                  } ) }
                </tbody>
              </table>
            </div>
          </div>
          <div className={style.divButtonSubmeter}
            onClick={this.handleToggle} > {strings.invoices.addInvoice} </div>
          <Dialog
            actions={ [
              { label: generalStrings.cancel, onClick: this.handleToggle },
              { label: generalStrings.submit, onClick: () => this.addExtraInvoice( initialState ),
                disabled: !state.active },
            ] }
            className={style.dialogBoxFormat}
            active={state.active}
            onEscKeyDown={this.handleToggle}
            onOverlayClick={this.handleToggle}>
            <CreateInvoice areInputFieldsValid={state.areInputFieldsValid}
              newInvoice={state.newInvoice} onChange={this.handleChange} />
          </Dialog>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/CreatePaymentAgreementPage/Invoices/index.js